var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsNumber, IsOptional, } from 'class-validator';
import { InsuranceName, VehicleModelType } from '../../../enums';
export class GetVehicleModelsReservableForD2CQueryDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "companyId", void 0);
__decorate([
    IsEnum(InsuranceName, { each: true }),
    IsOptional(),
    __metadata("design:type", String)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "insuranceName", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "pickUpAt", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "dropOffAt", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "driverAge", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "numberOfPeople", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "drivingExperience", void 0);
__decorate([
    Transform(({ obj, key }) => obj[key] === 'true'),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "cache", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "sureUserId", void 0);
__decorate([
    IsEnum(VehicleModelType),
    IsOptional(),
    __metadata("design:type", String)
], GetVehicleModelsReservableForD2CQueryDto.prototype, "vehicleType", void 0);
